import { getLoggedInUser } from './authUtils';

/**
 * Fetch data from given URL and return an object containing the HTTP status and response data.
 * This version throws an error if the response status is not OK.
 *
 * @param {string} url
 * @param {object} options
 * @returns {Promise<object>} An object with { status, ...data }
 */
const fetchJSON = (url, options = {}) => {
  const user = getLoggedInUser();

  // Helper to encode to Base64
  const encodeToBase64 = (input) => btoa(input);

  // Conditionally attach the Authorization header only if a valid user exists
  if (user && user.id_token) {
    const callerLocationUrl =
      (window && window.location && window.location.href) || 'No Location Can Be found';
    const stringToEncode = `${callerLocationUrl}||${user.id_token}`;
    const encodedString = encodeToBase64(stringToEncode);
    options.headers = {
      ...options.headers,
      Authorization: 'Bearer ' + encodedString,
    };
  } else {
    // Optionally log that no user is present (useful during login)
    console.warn('No user found; skipping Authorization header.');
  }
  return fetch(url, options).then(response => {
    // Check if there is no content.
    const contentLength = response.headers.get('content-length');
    if (contentLength && contentLength === '0') {
      if (!response.ok) {
        throw { status: response.status, message: '' };
      }
      return { status: response.status, message: '' };
    }
    return response.json().then(json => {
      if (!response.ok) {
        // Throw an error with the status and the parsed JSON error details.
        throw { status: response.status, ...json };
      }
      return { status: response.status, ...json };
    });
  });
};

export { fetchJSON };
